import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from "../UserContext";
import { FaTachometerAlt, FaUsers, FaUserTie, FaUserFriends, FaSignOutAlt, FaBars, FaEye, FaKey } from 'react-icons/fa';
import { RiAdminLine } from "react-icons/ri";
import { AiOutlineUserSwitch } from "react-icons/ai";
import './index.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { user, token, logout, rootToken, backLogin } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation(); // Get current location

  const role = user.role;
  const operatorName = user.operatorName;

  const menuRef = useRef(null);
  const dropdownRef = useRef(null);

  // Close menus on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true }); // ensures history is replaced
  };

  const handelDashboradShift = () => {
    if (role === "superadmin") {
      navigate("/superadmin");
    } else if (role === "admin") {
      navigate("/admin");
    } else if (role === "operator") {
      navigate("/operator")
    } else {
      logout();
    }
  }

  // Check if a nav link is active
  const isActiveLink = (path) => {
    // Exact match for dashboard links
    if (path === '/superadmin' || path === '/admin' || path === '/operator') {
      return location.pathname === path;
    }
    
    // For other links, check if current path starts with the link path
    return location.pathname.startsWith(path);
  };

  const handleBack = () => {
    backLogin();

    // decode role directly from rootToken
    if (rootToken) {
      const decoded = JSON.parse(atob(rootToken.split(".")[1]));
      const role = decoded.user?.role;

      if (role === "superadmin") navigate("/superadmin", { replace: true });
      else if (role === "admin") navigate("/admin", { replace: true });
      else if (role === "operator") navigate("/operator", { replace: true });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <img src="https://gsrtv.in/admin/gsrtv.png" alt="GSRTV" className="logo" onClick={() => handelDashboradShift()} />
        </div>
        
        <div className="header-right">
          <div ref={menuRef} className="hamburger-btn-ref" >
            <button 
              className="hamburger-btn" 
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <FaBars />
            </button>
            
            <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              {role === 'superadmin' && (
                <>
                  <NavLink to="/superadmin" icon={<FaTachometerAlt />} text="Dashboard" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/superadmin')} />
                  <NavLink to="/operators" icon={<FaUsers />} text="Operators" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/operators')} />
                  <NavLink to="/customers" icon={<FaUserFriends />} text="Customers" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/customers')} />
                  <NavLink to="/packages" icon={<FaUserFriends />} text="Packages" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/packages')} />
                </>
              )}
              {role === 'admin' && (
                <>
                  <NavLink to="/admin" icon={<FaTachometerAlt />} text="Dashboard" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/admin')} />
                  <NavLink to="/operators" icon={<FaUsers />} text="Operators" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/operators')} />
                  <NavLink to="/customers" icon={<FaUserFriends />} text="Customers" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/customers')} />
                  <NavLink to="/packages" icon={<FaUserFriends />} text="Packages" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/packages')} />
                </>
              )}
              {role === 'operator' && (
                <>
                  <NavLink to="/operator" icon={<FaTachometerAlt />} text="Dashboard" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/operator')} />
                  <NavLink to="/customers" icon={<FaUserFriends />} text="Customers" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/customers')} />
                  <NavLink to="/packages" icon={<FaUserFriends />} text="Packages" onClick={() => setMenuOpen(false)} isActive={isActiveLink('/packages')} />
                </>
              )}
            </nav>
          </div>

          {token && rootToken && token !== rootToken && (
            <button 
              className="profile-btn"
              onClick={() => handleBack()}
              aria-label="Profile switch"
            >
              <AiOutlineUserSwitch className="profile-icon"/>
            </button>
          )}
          
          <div className="profile-wrapper" ref={dropdownRef}>
            <button 
              className="profile-btn" 
              onClick={() => setDropdownOpen(!dropdownOpen)}
              aria-label="Profile menu"
            >
              <RiAdminLine className="profile-icon" />
            </button>

            {dropdownOpen && (
              <div className="profile-dropdown">
                <div className="profile-info">
                  <FaEye className="icon info-icon" />
                  <span>{operatorName} <span className="role-badge">{role}</span></span>
                </div>
                <button className="dropdown-item" onClick={() => navigate("/change-password")}>
                  <FaKey className="icon primary-icon" />
                  <span>Change Password</span>
                </button>
                <button className="dropdown-item logout-item" onClick={handleLogout}>
                  <FaSignOutAlt className="icon danger-icon" />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

const NavLink = ({ to, icon, text, onClick, isActive }) => (
  <Link to={to} className={`nav-link ${isActive ? 'active' : ''}`} onClick={onClick}>
    <span className="nav-icon">{icon}</span>
    <span className="nav-text">{text}</span>
  </Link>
);

export default Header;